import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  ADD_BILLINGPRICEDETAILS,
  ADD_BILLINGREQUESTAPPROVAL,
  ADD_BILLINGGENERATEINVOICE,
  GET_BILLINGINVOICEDETAILS,
  GET_BILLINGLIST,
  GET_BILLINGPRICEDETAILS,
  GET_BILLINGEXTRACHARGECALCULATION,
  ADD_BILLINGCONSOLIDATEDINVOICE,
  GET_BILLINGCONSOLIDATEDINVOICE,
  GET_CONSOLIDATE_INVOICE_MATRIX,
  GET_FINAL_INVOICE,
  ADD_BILLINGREQUESTAPPROVALLINK,
  GENERATE_CONSOLIDATED_PAYMENT_LINK,
  GET_CONSOLIDATED_PAYMENT_LINK,
  CHECK_CONSOLIDATED_PAYMENT_STATUS,
  CANCEL_CONSOLIDATED_PAYMENT_LINK,
  PATCH_INVOICE_TAXES,
  SEND_CONSOLIDATED_INVOICE_EMAIL,
  GET_BILLING_EMPLOYEES,
  GET_BILL_SELF_ELIGIBLE_INVOICES,
  GENERATE_BILL_SELF_CONSOLIDATED_INVOICE,
  GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST,
  GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS,
} from "resources/actionTypes";
import {
  addBillingPriceDetailsService,
  billingConsolidatedInvoiceService,
  billingExtraChargeCalcService,
  billingGenerateInvoiceService,
  billingInvoiceDetailsService,
  billingListService,
  billingPriceDetailsService,
  billingRequestApprovalService,
  consolidateInvoiceMatrixService,
  finalInvoiceService,
  getbillingConsolidatedInvoiceService,
  billingRequestApprovalLinkService,
  generateConsolidatedPaymentLinkApi,
  getConsolidatedPaymentLinkApi,
  getConsolidatedPaymentStatusApi,
  cancelConsolidatedPaymentLinkApi,
  updateInvoiceTaxesService,
  sendConsolidatedInvoiceEmailService,
  getBillingEmployeesService,
  getBillSelfEligibleInvoicesService,
  generateBillSelfConsolidatedInvoiceService,
  getBillSelfConsolidatedInvoicesListService,
  getBillSelfConsolidatedInvoiceDetailsService,
} from "services/BillingService";
import store from "redux/store";
import { getBillingList, getBillingInvoiceDetails, getBillSelfEligibleInvoices } from "redux/actions/BillingAction";
import { onLoaderTrigger } from "redux/actions/commonAction";
import { getReservationList } from "redux/actions/reservationAction";

function* getBillingListListener(action) {
  const payload = action.payload || {};
  const billingList = yield call(billingListService, payload);
  if (billingList.success) {
    yield put({
      type: GET_BILLINGLIST.GET_BILLINGLIST_SUCCESS,
      billingList: billingList,
    });
  } else {
    yield put({
      type: GET_BILLINGLIST.GET_BILLINGLIST_FAILED,
      message: billingList.message,
    });
    toast.error(billingList?.message || "Failed to Fetch BillingList");
  }
}
// 1. Generate Link Saga
function* generateConsolidatedPaymentLinkSaga(action) {
  try {
    const { consolidatedInvoiceId, callback } = action.payload;
    const response = yield call(
      generateConsolidatedPaymentLinkApi,
      consolidatedInvoiceId,
    );

    if (response.success) {
      yield put({
        type: GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_SUCCESS,
        payload: response.data,
      });
      toast.success(response.message || "Payment link generated successfully");
      if (callback) callback(response.data);
    } else {
      yield put({
        type: GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_FAILED,
        message: response.message,
      });
      toast.error(response.message || "Failed to generate payment link");
    }
  } catch (error) {
    yield put({
      type: GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_FAILED,
      message: error.message,
    });
    toast.error("Failed to generate payment link");
  }
}

// 2. Read Link Saga
function* getConsolidatedPaymentLinkSaga(action) {
  try {
    const { consolidatedInvoiceId, callback } = action.payload;
    const response = yield call(
      getConsolidatedPaymentLinkApi,
      consolidatedInvoiceId,
    );

    if (response.success) {
      yield put({
        type: GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_SUCCESS,
        payload: response.data,
      });
      if (callback) callback(response.data);
    } else {
      yield put({
        type: GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_FAILED,
        message: response.message,
      });
      toast.error(response.message || "No payment link found for this invoice");
    }
  } catch (error) {
    yield put({
      type: GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_FAILED,
      message: error.message,
    });
  }
}

// 3. Check Status Saga
function* checkConsolidatedPaymentStatusSaga(action) {
  try {
    const { consolidatedInvoiceId, callback } = action.payload;
    const response = yield call(
      getConsolidatedPaymentStatusApi,
      consolidatedInvoiceId,
    );

    if (response.success) {
      yield put({
        type: CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_SUCCESS,
        payload: response.data,
      });
      if (callback) callback(response.data);
    } else {
      yield put({
        type: CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_FAILED,
        message: response.message,
      });
      toast.error(response.message || "Failed to check payment status");
    }
  } catch (error) {
    yield put({
      type: CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_FAILED,
      message: error.message,
    });
  }
}

// 4. Cancel Link Saga
function* cancelConsolidatedPaymentLinkSaga(action) {
  try {
    const { consolidatedInvoiceId, callback } = action.payload;
    const response = yield call(
      cancelConsolidatedPaymentLinkApi,
      consolidatedInvoiceId,
    );

    if (response.success) {
      yield put({
        type: CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_SUCCESS,
        payload: response.data,
      });
      toast.success(response.message || "Payment link cancelled successfully");
      if (callback) callback(response.data);
    } else {
      yield put({
        type: CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_FAILED,
        message: response.message,
      });
      toast.error(response.message || "Failed to cancel payment link");
    }
  } catch (error) {
    yield put({
      type: CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_FAILED,
      message: error.message,
    });
  }
}

// Export sagas
export function* watchGenerateConsolidatedPaymentLink() {
  yield takeLatest(
    GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_REQUESTED,
    generateConsolidatedPaymentLinkSaga,
  );
}
export function* watchGetConsolidatedPaymentLink() {
  yield takeLatest(
    GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_REQUESTED,
    getConsolidatedPaymentLinkSaga,
  );
}
export function* watchCheckConsolidatedPaymentStatus() {
  yield takeLatest(
    CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_REQUESTED,
    checkConsolidatedPaymentStatusSaga,
  );
}
export function* watchCancelConsolidatedPaymentLink() {
  yield takeLatest(
    CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_REQUESTED,
    cancelConsolidatedPaymentLinkSaga,
  );
}
export function* getBillingListWatcher() {
  yield takeEvery(
    GET_BILLINGLIST.GET_BILLINGLIST_REQUESTED,
    getBillingListListener,
  );
}

function* getBillingDetails(action) {
  const payload = action.payload || {};
  const billingInvoiceDetails = yield call(
    billingInvoiceDetailsService,
    payload,
  );
  if (billingInvoiceDetails.success) {
    yield put({
      type: GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_SUCCESS,
      billingInvoiceDetails: billingInvoiceDetails,
    });
  } else {
    yield put({
      type: GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_FAILED,
      message: billingInvoiceDetails.message,
    });
    toast.error(
      billingInvoiceDetails?.message ||
        "Failed to Fetch billing Invoice Details",
    );
  }
}

export function* getBillingDetailsWatcher() {
  yield takeEvery(
    GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_REQUESTED,
    getBillingDetails,
  );
}

// Billing Details
function* getBillingPriceDetails(action) {
  const payload = action.payload || {};
  const billingPrice = yield call(billingPriceDetailsService, payload);
  if (billingPrice.success) {
    yield put({
      type: GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_SUCCESS,
      billingPriceDetails: billingPrice,
    });
  } else {
    yield put({
      type: GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_FAILED,
      message: billingPrice.message,
    });
    toast.error(
      billingPrice?.message || "Failed to Fetch billing Price Details",
    );
  }
}

export function* getBillingPriceDetailsWatcher() {
  yield takeEvery(
    GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_REQUESTED,
    getBillingPriceDetails,
  );
}

// add Billing Price Details
function* addtBillingPriceDetails(action) {
  const payload = action.payload || {};
  const billingPrice = yield call(addBillingPriceDetailsService, payload);
  if (billingPrice.success) {
    yield put({
      type: ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_SUCCESS,
      billingPriceDetails: billingPrice,
    });
    //navigate to invoice page after invoice is generated
    payload?.navigate();
  } else {
    yield put({
      type: ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_FAILED,
      message: billingPrice.message,
    });
    toast.error(billingPrice?.message || "Failed to Add billing Price Details");
  }
}

export function* addtBillingPriceDetailsWatcher() {
  yield takeEvery(
    ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_REQUESTED,
    addtBillingPriceDetails,
  );
}

// Billing Request Approval
function* postBillingRequestApproval(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingRequest = yield call(
    billingRequestApprovalService,
    payload?.dataObj,
  );
  if (billingRequest.success) {
    yield put({
      type: ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_SUCCESS,
      billingRequest: billingRequest,
    });
    // payload?.toggle();
    toast.success("Email Sent Successfully");
  } else {
    yield put({
      type: ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_FAILED,
      message: billingRequest.message,
    });
    toast.error(billingRequest?.message || "Failed to Fetch billing Request");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingRequestApprovalWatcher() {
  yield takeEvery(
    ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_REQUESTED,
    postBillingRequestApproval,
  );
}

// Billing Consolidated Invoice
function* postBillingConsolidatedInvoice(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingConsolidatedRequest = yield call(
    billingConsolidatedInvoiceService,
    payload?.dataObj,
  );
  if (billingConsolidatedRequest.success) {
    toast.success(billingConsolidatedRequest.message);
    yield put({
      type: ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_SUCCESS,
      billingConsolidatedRequest: billingConsolidatedRequest,
    });
    payload?.handleTotalAmount();
    store.dispatch(getBillingList(payload?.billingListPayload));
  } else {
    yield put({
      type: ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_FAILED,
      message: billingConsolidatedRequest.message,
    });
    toast.error(
      billingConsolidatedRequest?.message ||
        "Failed to Add billing Consolidated Invoice",
    );
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingConsolidatedInvoiceWatcher() {
  yield takeEvery(
    ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED,
    postBillingConsolidatedInvoice,
  );
}

//get  Billing Consolidated Invoice
function* getBillingConsolidatedInvoice(action) {
  const payload = action.payload || {};
  const billingConsolidatedInvoice = yield call(
    getbillingConsolidatedInvoiceService,
    payload,
  );
  if (billingConsolidatedInvoice?.success) {
    yield put({
      type: GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_SUCCESS,
      billingConsolidatedInvoice: billingConsolidatedInvoice,
    });
  } else {
    yield put({
      type: GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_FAILED,
      message: billingConsolidatedInvoice?.message,
    });
    toast.error(
      billingConsolidatedInvoice.message ||
        "Failed to fetch consolidated Invoice",
    );
  }
}

export function* getBillingConsolidatedInvoiceWatcher() {
  yield takeEvery(
    GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED,
    getBillingConsolidatedInvoice,
  );
}

//Billing generate perfoma invoice
function* postBillingGenerateInvoice(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingGenerateInvoice = yield call(
    billingGenerateInvoiceService,
    payload,
  );
  if (billingGenerateInvoice.success) {
    toast.success(
      billingGenerateInvoice?.message || "Invoice Generated Successfully",
    );
    payload?.handleBack();
    yield put({
      type: ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_SUCCESS,
      billingGenerateInvoice: billingGenerateInvoice,
    });
  } else {
    yield put({
      type: ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_FAILED,
      message: billingGenerateInvoice.message,
    });
    toast.error(
      billingGenerateInvoice?.message ||
        "Failed to Fetch Billing generate Invoice",
    );
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingGenerateInvoiceWatcher() {
  yield takeEvery(
    ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_REQUESTED,
    postBillingGenerateInvoice,
  );
}

//Billing extra charge calculation
function* getBillingExtraChargeCalc(action) {
  const payload = action.payload || {};
  const extraCharges = yield call(billingExtraChargeCalcService, payload);
  if (extraCharges.success) {
    yield put({
      type: GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_SUCCESS,
      chargesCalculations: extraCharges,
    });
  } else {
    yield put({
      type: GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_FAILED,
      message: extraCharges.message,
    });
    toast.error(
      extraCharges?.message || "Failed to Fetch Billing Extra charges",
    );
  }
}

export function* getBillingExtraChargeCalcWatcher() {
  yield takeEvery(
    GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_REQUESTED,
    getBillingExtraChargeCalc,
  );
}

//Consolidate Matrix Billing
function* getConsolidateInvoiceMatrix(action) {
  const payload = action.payload || {};
  const consolidateInvoiceMatrix = yield call(
    consolidateInvoiceMatrixService,
    payload,
  );
  if (consolidateInvoiceMatrix.success) {
    yield put({
      type: GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_SUCCESS,
      consolidateInvoiceMatrix: consolidateInvoiceMatrix,
    });
  } else {
    yield put({
      type: GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_FAILED,
      message: consolidateInvoiceMatrix.message,
    });
    toast.error(
      consolidateInvoiceMatrix?.message ||
        "Failed to fetch Consolidate Invoice Matrix",
    );
  }
}

export function* getConsolidateInvoiceMatrixWatcher() {
  yield takeEvery(
    GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED,
    getConsolidateInvoiceMatrix,
  );
}

// Final Invoice billing
function* getFinalInvoiceData(action) {
  const payload = action.payload || {};
  const finalInvoiceData = yield call(finalInvoiceService, payload);
  if (finalInvoiceData.success) {
    yield put({
      type: GET_FINAL_INVOICE.GET_FINAL_INVOICE_SUCCESS,
      finalInvoiceData: finalInvoiceData,
    });
  } else {
    yield put({
      type: GET_FINAL_INVOICE.GET_FINAL_INVOICE_FAILED,
      message: finalInvoiceData?.message,
    });
    toast.error(
      finalInvoiceData?.message || "Failed to fetch Final Invoice Data",
    );
  }
}
export function* getFinalInvoiceWatcher() {
  yield takeEvery(
    GET_FINAL_INVOICE.GET_FINAL_INVOICE_REQUESTED,
    getFinalInvoiceData,
  );
}

// Billing Request Approval Link
function* postBillingRequestApprovalLink(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingRequestLink = yield call(
    billingRequestApprovalLinkService,
    payload?.dataObj,
  );
  if (billingRequestLink.success) {
    yield put({
      type: ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_SUCCESS,
      billingRequest: billingRequestLink,
    });
    payload?.toggle();
  } else {
    yield put({
      type: ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_FAILED,
      message: billingRequestLink.message,
    });
    toast.error(
      billingRequestLink?.message || "Failed to Generate billing Request",
    );
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingRequestApprovalLinkWatcher() {
  yield takeEvery(
    ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED,
    postBillingRequestApprovalLink,
  );
}

function* patchInvoiceTaxesSaga(action) {
  const { tripId, payload, isPrivate, magicToken, onSuccess } = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  try {
    const res = yield call(updateInvoiceTaxesService, tripId, payload);
    if (res?.success) {
      toast.success(res?.message || "Invoice taxes updated successfully");
      yield put({
        type: PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_SUCCESS,
      });
      if (onSuccess) onSuccess();
      if (isPrivate) {
        yield put(getBillingInvoiceDetails(tripId, "private"));
      } else {
        yield put(getBillingInvoiceDetails(magicToken, "public"));
      }
    } else {
      yield put({
        type: PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_FAILED,
        message: res?.message || "Failed to update invoice taxes",
      });
      toast.error(res?.message || "Failed to update invoice taxes");
    }
  } catch (err) {
    yield put({
      type: PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_FAILED,
      message: err.message,
    });
    toast.error(err?.message || "Failed to update invoice taxes");
  } finally {
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* patchInvoiceTaxesWatcher() {
  yield takeEvery(
    PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_REQUESTED,
    patchInvoiceTaxesSaga,
  );
}

// 5. Send Consolidated Invoice Email
function* sendConsolidatedInvoiceEmailSaga(action) {
  const { invoiceId, recipients, callback } = action.payload;
  try {
    const response = yield call(
      sendConsolidatedInvoiceEmailService,
      invoiceId,
      recipients,
    );
    if (response?.success) {
      yield put({
        type: SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_SUCCESS,
        payload: response.data,
      });
      if (response.data?.emailSent) {
        toast.success(response.message || "Invoice sent successfully");
      } else {
        toast.error(
          response.message ||
            "Invoice request processed but email sending failed",
        );
      }
      if (callback) callback(response.data);
    } else {
      yield put({
        type: SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_FAILED,
        message: response?.message,
      });
      toast.error(response?.message || "Failed to send invoice email");
    }
  } catch (error) {
    yield put({
      type: SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_FAILED,
      message: error.message,
    });
    toast.error("Failed to send invoice email");
  }
}

export function* watchSendConsolidatedInvoiceEmail() {
  yield takeLatest(
    SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_REQUESTED,
    sendConsolidatedInvoiceEmailSaga,
  );
}

// 1. Get Billing Employees Saga
function* getBillingEmployeesSaga(action) {
  const { companyId, page, pageSize, status } = action.payload;
  try {
    const response = yield call(getBillingEmployeesService, companyId, page, pageSize, status);
    if (response?.success) {
      yield put({
        type: GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_FAILED,
        message: response?.message,
      });
    }
  } catch (error) {
    yield put({
      type: GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_FAILED,
      message: error.message,
    });
  }
}

// 2. Get Eligible Bill-Self Invoices Saga
function* getBillSelfEligibleInvoicesSaga(action) {
  const { companyId, cityId, employeeId, page, pageSize, dateFrom, dateTo } = action.payload;
  try {
    const response = yield call(getBillSelfEligibleInvoicesService, companyId, cityId, employeeId, page, pageSize, dateFrom, dateTo);
    if (response?.success) {
      yield put({
        type: GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_FAILED,
        message: response?.message,
      });
    }
  } catch (error) {
    yield put({
      type: GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_FAILED,
      message: error.message,
    });
  }
}

// 3. Generate Bill-Self Consolidated Invoice Saga
function* generateBillSelfConsolidatedInvoiceSaga(action) {
  const { payload, billingListPayload, onSuccess } = action.payload;
  store.dispatch(onLoaderTrigger(true));
  try {
    const response = yield call(generateBillSelfConsolidatedInvoiceService, payload);
    if (response?.success) {
      toast.success(response.message || "Consolidated invoice generated successfully");
      yield put({
        type: GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_SUCCESS,
        payload: response.data,
      });
      if (onSuccess) onSuccess();
      // Fetch eligible invoices or update list
      store.dispatch(getBillSelfEligibleInvoices(
        billingListPayload.companyId,
        billingListPayload.city,
        billingListPayload.employeeId
      ));
    } else {
      yield put({
        type: GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_FAILED,
        message: response?.message,
      });
      toast.error(response?.message || "Failed to generate consolidated invoice");
    }
  } catch (error) {
    yield put({
      type: GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_FAILED,
      message: error.message,
    });
    toast.error("Failed to generate consolidated invoice");
  } finally {
    store.dispatch(onLoaderTrigger(false));
  }
}

// 4. Get Bill-Self Consolidated Invoices List Saga
function* getBillSelfConsolidatedInvoicesListSaga(action) {
  try {
    const response = yield call(getBillSelfConsolidatedInvoicesListService, action.payload);
    if (response?.success) {
      yield put({
        type: GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_FAILED,
        message: response?.message,
      });
    }
  } catch (error) {
    yield put({
      type: GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_FAILED,
      message: error.message,
    });
  }
}

// 5. Get Bill-Self Consolidated Invoice Details Saga
function* getBillSelfConsolidatedInvoiceDetailsSaga(action) {
  const { id } = action.payload;
  try {
    const response = yield call(getBillSelfConsolidatedInvoiceDetailsService, id);
    if (response?.success) {
      yield put({
        type: GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_FAILED,
        message: response?.message,
      });
    }
  } catch (error) {
    yield put({
      type: GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_FAILED,
      message: error.message,
    });
  }
}

export function* watchGetBillingEmployees() {
  yield takeLatest(GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_REQUESTED, getBillingEmployeesSaga);
}

export function* watchGetBillSelfEligibleInvoices() {
  yield takeLatest(GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_REQUESTED, getBillSelfEligibleInvoicesSaga);
}

export function* watchGenerateBillSelfConsolidatedInvoice() {
  yield takeLatest(GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_REQUESTED, generateBillSelfConsolidatedInvoiceSaga);
}

export function* watchGetBillSelfConsolidatedInvoicesList() {
  yield takeLatest(GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_REQUESTED, getBillSelfConsolidatedInvoicesListSaga);
}

export function* watchGetBillSelfConsolidatedInvoiceDetails() {
  yield takeLatest(GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_REQUESTED, getBillSelfConsolidatedInvoiceDetailsSaga);
}
